import dayjs from "./dayjs";

export const convertToUtc = (val) => {
  return val ? new Date(val).toISOString() : "";
};

// ── Date-range boundaries ────────────────────────────────────────────────────
// Use these for EVERY from/to filter instead of convertToUtc.
//
// The pickers hand back a date with no meaningful time (often literally
// "MM/DD/YYYY"), so `convertToUtc(toDate)` produced MIDNIGHT AT THE START of the
// end day. Backends filter `date <= toDate`, so the end day was excluded
// entirely — picking 10-Jul → 19-Jul returned records only up to the 18th.
// Worse, on a UTC+n browser that midnight converts to the previous day in UTC,
// so the last n hours of the 18th vanished too.
//
// toRangeEndUtc snaps to 23:59:59.999 of the selected day in the USER'S OWN
// timezone — the day they actually picked in the calendar — then converts to
// UTC for the API. toRangeStartUtc does the same at 00:00:00.000.
//
// Both are idempotent: a value already at a day boundary stays put, so they are
// safe to apply to call sites that were already correct.
export const toRangeStartUtc = (val) =>
  val && dayjs(val).isValid() ? dayjs(val).startOf("day").toISOString() : "";

export const toRangeEndUtc = (val) =>
  val && dayjs(val).isValid() ? dayjs(val).endOf("day").toISOString() : "";

export const combineUtcDateTime = (date, time) => {
  const d = dayjs.utc(date);
  const t = dayjs.utc(time);

  return d.hour(t.hour()).minute(t.minute()).second(t.second()).millisecond(0);
};

export const getTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const GetHours = (
  startTime = dayjs().hour(8).minute(0).second(0),
  endTime = dayjs().hour(22).minute(0).second(0),
) => {
  const timeList = [];

  let currentTime = startTime;
  while (currentTime.isSameOrBefore(endTime)) {
    timeList.push(currentTime.format("h:mm A"));
    currentTime = currentTime.add(1, "hour");
  }
  return timeList;
};

export const GetMonths = () => {
  const date = new Date();
  return [
    `01/${date.getFullYear()}`,
    `02/${date.getFullYear()}`,
    `03/${date.getFullYear()}`,
    `04/${date.getFullYear()}`,
    `05/${date.getFullYear()}`,
    `06/${date.getFullYear()}`,
    `07/${date.getFullYear()}`,
    `08/${date.getFullYear()}`,
    `09/${date.getFullYear()}`,
    `10/${date.getFullYear()}`,
    `11/${date.getFullYear()}`,
    `12/${date.getFullYear()}`,
  ];
};

export const getDaysByMonth = (month) => {
  const daysInMonth = dayjs(month, "YYYY/MM").daysInMonth();
  return Array.from({ length: daysInMonth }, (v, k) => k + 1);
};

export const getCurrentWeek = () => {
  const today = dayjs();
  const startOfWeek = today.startOf("week");
  const endOfWeek = today.endOf("week");

  const weekDays = [];
  let currentDay = startOfWeek;

  while (currentDay.isSameOrBefore(endOfWeek, "day")) {
    weekDays.push(currentDay.format("MMM DD"));
    currentDay = currentDay.add(1, "day");
  }

  return weekDays;
};

export const GetDueDate = (date) => {
  return `${dayjs(date, "mm/DD/yyyy").format("DD")}/${dayjs().format(
    "MM/yyyy",
  )}`;
};
